export const websitePattern = /^(https?:\/\/)?([\w\-\.\_~%]+(\.[a-zA-Z]{2,}))([/\w\-\.\_~:\?=\&%]*)$/;
export const emailPattern = /^[A-Za-z0-9._+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/;
export const linkedInPattern = /^https:\/\/www\.linkedin\.com\/[\w\-\.\?\=\/]*$/;
export const twitterPattern = /^https:\/\/(?:twitter|x)\.com\/[\w\-\.\?\=\/]*$/;
export const facebookPattern = /^https:\/\/facebook\.com\/[\w\-\.\?\=\/]*$/;
export const instagramPattern = /^https:\/\/www\.instagram\.com\/[\w\-\.\?\=\/]*$/;
export const youtubePattern = /^https:\/\/www\.youtube\.com\/[\w\-\.\?\=\/]*$/;
export const tiktokPattern = /^https:\/\/www\.tiktok\.com\/[\w\-\.\?\=\/]*$/;
export const githubPattern = /^https:\/\/github\.com\/[\w\-\.\?\=\/]*$/;
export const mediumPattern = /^https:\/\/medium\.com\/[\w\-\.\?\=\/]*$/;
export const textPattern = /^[a-zA-Z0-9\s(),;.?()\-\$%*!@/+'"&:<>]+$/;
export const imageExtensionPattern = /\.(png|jpg|jpeg)$/i;
export const phonePattern = /^\+?[0-9\s\-\(\)]+$/;
export const namePattern = /^[a-zA-Z\s\-']+$/;
